import { Locale, type LocalizedString } from "../Locale.js";

export const ourApproachAnchorMap = {
	processAnalysis: {
		[Locale.cs]: "procesni-analyza",
		[Locale.en]: "process-analysis",
	},
	concept: {
		[Locale.cs]: "koncept",
		[Locale.en]: "concept",
	},
	detailedDesign: {
		[Locale.cs]: "detailni-design",
		[Locale.en]: "detailed-design",
	},
	implementation: {
		[Locale.cs]: "implementace",
		[Locale.en]: "implementation",
	},
	serviceAndSupport: {
		[Locale.cs]: "servis-a-udrzba",
		[Locale.en]: "service-and-support",
	},
	contactUs: {
		[Locale.cs]: "kontaktujte-nas",
		[Locale.en]: "contact-us",
	},
} satisfies Record<string, LocalizedString>;
